import { PaymentForm, CreditCard } from "react-square-web-payments-sdk";
import "./styles.scss";
import { toast } from "sonner";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { currencyFormat } from "@/utils/function";
import {
  API_URL,
  APPLICATION_ID,
  SQUARE_LOCATION_ID,
} from "@/services/constants";

export const AddMoney = () => {
  const [values, updateValues] = useState({
    data: "",
    loading: false,
    error: "",
  });
  const navigate = useNavigate();
  const location = useLocation();

  const { amount } = location.state;

  const handlePayment = async (nonce: any) => {
    updateValues({ ...values, loading: true });

    const token = localStorage.getItem("pluri_token");

    const raw = JSON.stringify({
      nonce: nonce,
      amount: Number(amount),
      currency: "USD",
    });

    try {
      const response = await fetch(`${API_URL}/payments/add-money`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json; charset=utf-8",
        },
        body: raw,
      });

      if (!response.ok) {
        updateValues({ ...values, loading: false });
        toast.error(`Payment failed with status ${response.status}`, {
          richColors: true,
        });
      } else {
        updateValues({ ...values, loading: false });
        const data = await response.json();
        console.log("Payment successful:", data);
        toast.success("Payment successful!", {
          richColors: true,
          duration: 7000,
        });
        navigate(-1);
      }
    } catch (error: any) {
      updateValues({ ...values, loading: false });
      console.error("Payment failed:", error.message);
      toast.error("Payment failed. Please try again.", { richColors: true });
    }
  };

  return (
    <div className="container">
      <PaymentForm
        applicationId={APPLICATION_ID || ""}
        locationId={SQUARE_LOCATION_ID || ""}
        cardTokenizeResponseReceived={(token) => {
          if (token.status === "OK") {
            handlePayment(token.token);
          } else {
            toast.error("Something went wrong...", { richColors: true });
          }
        }}
      >
        <CreditCard
          buttonProps={{
            isLoading: values.loading,
            css: {
              "[data-theme='dark'] &": {
                backgroundColor: "#61dafb",
                color: "var(--ifm-color-emphasis-100)",
                "&:hover": {
                  backgroundColor: "#0091ea",
                },
              },
              backgroundColor: "#771520",
              fontSize: "14px",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#530f16",
                color: "#fff",
              },
            },
          }}
          style={{
            input: {
              fontSize: "14px",
            },
            "input::placeholder": {
              color: "#771520",
            },
          }}
        >
          {values.loading
            ? `Processing ${currencyFormat(amount)}`
            : `Pay ${currencyFormat(amount)}`}
        </CreditCard>
      </PaymentForm>
    </div>
  );
};
